/**
 * Главная страница админки (/admin) — разметка 1:1 из legacy
 * htdocs/core/templates/admin_main.tpl: редактор материала materials.name='main'.
 *
 * Соответствие legacy:
 *   .infobox.clearfix + p.okke     — сообщения об ошибке/успехе
 *   form.add-form                  — форма
 *   .form-control > span + input   — «Заголовок страницы:»
 *   #main_text.in_editor           — визуальный редактор (в legacy — summernote)
 *   #main_textarea.hidden          — скрытое поле text, куда summernote клал HTML
 *   input.bt.orange                — «сохранить изменения»
 *
 * Вместо jQuery-плагина summernote стоит общий React-редактор (components/HtmlEditor,
 * TipTap) — тот же, что на страницах новостей, информации и email-рассылки.
 * HTML на входе и выходе не меняется.
 *
 * API: GET/POST /api/admin/content/main (Handlers\Admin\Content::main / saveMain).
 */

import { useEffect, useState, type FormEvent } from 'react'

import { api, ApiError } from '@/api/client'
import type { Material } from '@/api/types'
import { HtmlEditor } from '@/components/HtmlEditor'
import { useApi } from '@/lib/useApi'

interface SaveResult {
  message: string
}

export function AdminMainPage() {
  const { data } = useApi<Material | null>('/api/admin/content/main')
  const [title, setTitle] = useState('')
  const [text, setText] = useState('')
  const [errors, setErrors] = useState<string[]>([])
  const [oks, setOks] = useState<string[]>([])

  useEffect(() => {
    if (data == null) return
    setTitle(data.title)
    setText(data.text)
  }, [data])

  async function submit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault()
    setErrors([])
    setOks([])
    try {
      const result = await api.post<SaveResult>('/api/admin/content/main', { title, text })
      setOks([result.message])
    } catch (e: unknown) {
      setErrors([e instanceof ApiError ? e.message : 'Ошибка сохранения'])
    }
  }

  return (
    <>
      <div className="infobox clearfix">
        {errors.map((error) => (
          <p key={error} className="okke" style={{ color: '#ce4844', float: 'left' }}>
            {error}
          </p>
        ))}
        {oks.map((ok) => (
          <p key={ok} className="okke" style={{ float: 'left' }}>
            {ok}
          </p>
        ))}
      </div>
      <form className="add-form" method="POST" onSubmit={(event) => void submit(event)}>
        <div className="form-control" style={{ paddingBottom: 6, display: 'table' }}>
          <span
            style={{ width: 120, display: 'table-cell', color: '#999', fontSize: '11px' }}
          >
            Заголовок страницы:&nbsp;
          </span>
          <input
            name="title"
            style={{ display: 'table-cell', border: 0, outline: 0, width: '100%' }}
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            placeholder="Заголовок"
          />
        </div>
        <br />
        <HtmlEditor value={text} onChange={setText} />
        <div style={{ textAlign: 'center' }}>
          <input type="submit" name="main-submit" className="bt orange" value="сохранить изменения" />
        </div>
      </form>
    </>
  )
}
